import { createRequestTypes } from "../utils/helpers";
import {
  httpGetAndDispatchAction,
} from "./_utils";

export const GET_PUBLIC_SYSTEM_CONFIG = createRequestTypes("GET_PUBLIC_SYSTEM_CONFIG");
export const GET_PUBLIC_SYSTEM_SUFFIX = createRequestTypes("GET_PUBLIC_SYSTEM_SUFFIX");

/**
 * Get Device Profiles (or Equipment Families)
 * @returns Promise<Response>
 */
export const getPublicSystemConfig = () =>
  httpGetAndDispatchAction(GET_PUBLIC_SYSTEM_CONFIG, "/public/system_configurations", null);

export const getPublicSystemSuffix = () =>
  httpGetAndDispatchAction(GET_PUBLIC_SYSTEM_SUFFIX, "/public/system_suffixes", null);
